module.exports = __webpack_public_path__ + "img/61_12.6312e2c1.png";